/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';

import PhoneInput from './phone-input';
import './phone-input/styles/bootstrap.css';

import * as S from '../../styles';

export interface IPhoneNumberInputProps {
  id: string;
  label?: string;
  value?: string;
  errorText?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  labelColor?: string;
  hasError?: boolean;
  onCompChange?(id: string, payload: any): void;
}

export const PhoneNumberInput = ({
  id,
  label,
  hasError,
  errorText,
  value,
  required,
  placeholder,
  onCompChange,
  labelColor,
}: IPhoneNumberInputProps) => {
  const [textValue, setTextValue] = useState(value ?? '');
  console.log(`hasError:`, hasError);
  const onChange = (id: string, e: any, country, formattedNumber) => {
    const number = `+${e}`;
    setTextValue(number);
    onCompChange && onCompChange(id, number);
  };
  const _renderLabelIf = () => {
    if (label) {
      return (
        <S.FormLabel color={labelColor}>
          {label}
          {required && <sup style={{ color: 'red' }}>*</sup>}
        </S.FormLabel>
      );
    }
    return null;
  };

  const _renderErrorTextIf = () => {
    if (hasError) {
      return (
        <S.FeedbackOtherLabel type="tooltip">{errorText}</S.FeedbackOtherLabel>
      );
    }
    return null;
  };

  return (
    <>
      <Form.Group id={id} className="mb-4 formgroup">
        {_renderLabelIf()}
        <InputGroup>
          <PhoneInput
            className="formcontrol shadow-none"
            onChange={onChange.bind(null, id)}
            required={required}
            value={textValue}
            placeholder={placeholder}
            enableSearch={true}
            copyNumbersOnly={false}
          />
          <InputGroup>{_renderErrorTextIf()}</InputGroup>
        </InputGroup>
      </Form.Group>
    </>
  );
};

PhoneNumberInput.defaultProps = {
  required: false,
  hasError: false,
};
